import { Component, OnInit, inject } from '@angular/core';
import { DataAccessService } from '../core/services/data-access.service';
import { MatButton } from '@angular/material/button';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-configmodules',
    templateUrl: './configmodules.component.html',
    styleUrls: ['./configmodules.component.scss'],
    imports: [MatButton, RouterLinkActive, RouterLink]
})
export class ConfigmodulesComponent implements OnInit {
  private dataAccess = inject(DataAccessService);

  ngOnInit() {
  }

  haveAccessToModule(module: string): boolean {
    return this.dataAccess.haveAccessToModule(module);
  }


}
